import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Briefcase, ArrowRight, AlertCircle } from 'lucide-react';
import { Card, Button } from '../../../ui';
import { leadsService } from '../../../services/leads.service';
import { useAuth } from '../../../contexts/AuthContext';
import { useProduct } from '../../../contexts/ProductContext';

interface HojeMetrics {
  total: number;
  due: number;
}

export function PipelineHojeBlock() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { selectedProductId } = useProduct();

  const { data } = useQuery<HojeMetrics>({
    queryKey: ['hoje-pipeline', user?.id, selectedProductId],
    queryFn: async () => {
      const result = await leadsService.list({
        productId: selectedProductId,
        assignedUserId: user?.id,
        limit: 200,
      });
      const leads: Array<{ nextFollowUpAt?: string | null }> =
        result?.leads ?? result?.items ?? result ?? [];
      const now = new Date();
      const due = leads.filter((l) => l.nextFollowUpAt && new Date(l.nextFollowUpAt) < now).length;
      return { total: leads.length, due };
    },
    enabled: !!selectedProductId && !!user?.id,
  });

  return (
    <Card>
      <div className="flex items-start justify-between">
        <div>
          <h2 className="font-serif text-lg text-ink-primary">Seus leads</h2>
          <p className="text-sm text-ink-secondary mt-1">
            {data ? `${data.total} atribuído${data.total !== 1 ? 's' : ''}` : 'Carregando…'}
          </p>
        </div>
        <Briefcase className="w-5 h-5 text-ink-tertiary" />
      </div>

      {data && data.due > 0 && (
        <div className="mt-3 inline-flex items-center gap-1 text-sm text-danger">
          <AlertCircle className="w-4 h-4" />
          <span>
            {data.due} follow-up{data.due !== 1 ? 's' : ''} vencido
            {data.due !== 1 ? 's' : ''}
          </span>
        </div>
      )}

      <div className="mt-4 flex flex-wrap gap-2">
        <Button
          variant="secondary"
          size="sm"
          icon={<ArrowRight className="w-4 h-4" />}
          iconPosition="right"
          onClick={() => navigate('/pipeline')}
        >
          Abrir pipeline
        </Button>
        {data && data.due > 0 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/pipeline?view=list&filter=due')}
          >
            Ver vencidos
          </Button>
        )}
      </div>
    </Card>
  );
}
